import SurveyEditor from "@/features/surveys/editor/SurveyEditor";
import { storageService } from "@/services/StorageService";
import { useLocation, useNavigate } from "react-router-dom";

export default function NewSurveyPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { templateSurvey } = location.state || {};
  if (templateSurvey) {
    // clear the id field so that it gets regenerated
    delete templateSurvey.id;
  }

  function onSubmit(survey: any) {
    storageService.saveSurvey(survey);
    navigate(`/surveys/${survey.id}`);
  }

  return (
    <>
      <SurveyEditor onSubmit={onSubmit} survey={templateSurvey} />
    </>
  );
}
